<template>
  <div class="Div">
    <section class="sectionContent">
     <labars-bread></labars-bread>
      <ul>
        <li
          class="li"
          v-for="(item,i) of footBanner"
          :key="i"
          @click="detailClick(item)"
        >
          <img
            class="titleImg"
            :src="item.cover_img"
            alt=""
          >
          <div class="name ellipsis">
            {{item.album_title_cn}}
          </div>
        </li>
      </ul>
      <el-pagination
        :background="true"
        :hide-on-single-page="true"
        layout="prev, pager, next"
        :total="total"
        class="page"
        :current-page="page"
        @current-change="changePage"
        :page-size='9'
      >
      </el-pagination>
    </section>
  </div>
</template>
<script>
import { GalleryGetList } from "@/api/Album";
import LabarsBread from "../../layout/LabarsBread";
export default {
  name: "GalleryLists",
  data() {
    return {
      page: 1,
      footBanner: [],//相册
      total:1,//总数
    };
  },
  components: {
    LabarsBread
  },
  methods: {
    //   翻页
    changePage(val) {
      this.page = val;
      this.GalleryList()
    },
    // 跳转详情
    detailClick(item) {
      // this.$router.push({ path: "/GalleryDetail" });
      var laber = JSON.parse(this.$route.query.laber);
      var laPath = JSON.parse(this.$route.query.laPath);
      laPath.push(this.$route.path)
      laber.push(18);
      var routeData=this.$router.resolve({
        path: "/GalleryDetail",
        query: { laber: JSON.stringify(laber),id:item.album_id,laPath: JSON.stringify(laPath) }
      });
      window.open(routeData.href, "_blank");
    },
    // 获取相册内容
    GalleryList() {
      GalleryGetList({
        address: 3,
        per_page:9,
        page:this.page,
      }).then(res => {
        // console.log(res.data);
        this.footBanner=res.data.list
        this.total=Number(res.data.count)
      });
    }
  },
  created(){
    this.GalleryList()
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  height: 100%;
  //   padding: 0.1px 0;
  background: #f5f5f5;
}
section {
  padding: 0.1px;
}
.sectionContent {
  width: px2Rem(1300px);
  margin: auto;
  ul {
    // background: rgba(255, 255, 255, 1);
    margin-bottom: px2Rem(40px);
    font-size: 0;
  }
  .li {
    display: inline-block;
    width: px2Rem(400px);
    // height: px2Rem(320px);
    margin-right: px2Rem(48px);
    margin-bottom: px2Rem(16px);
    // background: rgba(255, 255, 255, 1);

    border-radius: 8px;
    transition: 0.3s;
    cursor: pointer;
    &:nth-of-type(3n) {
      margin-right: 0;
    }

    &:hover {
      box-shadow: 0px 5px 5px 5px rgba(0, 0, 0, 0.16);
      .name {
        color: #1c3278;
      }
    }
    .titleImg {
      display: inline-block;
      width: 100%;
      height: px2Rem(246px);
      //   margin-right: px2Rem(30px);
    }
    .name {
      padding: px2Rem(24px);
      font-size: px2Rem(30px);
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }
}
.page {
  margin-top: px2Rem(20px);
  margin-bottom: px2Rem(65px);
  text-align: center;
  //   background: #fff;
  /deep/ .btn-prev,
  /deep/ .btn-next,
  /deep/ .el-pager li {
    background-color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/SchoolNews/GalleryLists.vue